import { useState, useEffect } from "react";
import axios from "axios";
import classes from "./PDFSlider.module.css";
import deleteIcon from "../assets/delete_icon_red.png";

const Image = ({
  imagePath,
  className,
  setDeleteModal,
  onClick,
  fileId,
  fileName,
  mode,
  imgClasses = "",
}) => {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const fetchImage = async () => {
      const imageID = imagePath.split("/").pop();

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/image/${imageID}`,
          {
            responseType: "blob",
          }
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = URL.createObjectURL(blob);
        setImageUrl(url);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    fetchImage();

    // Cleanup function to revoke object URL to avoid memory leaks
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [imagePath]);

  const handleClick = () => {
    if (onClick) {
      onClick(imageUrl);
    }
  };

  const handleDeleteModal = (e) => {
    e.stopPropagation();
    setDeleteModal({
      visible: true,
      documentId: fileId,
    });
  };

  return (
    <div
      className={`${className} ${mode !== "show" ? classes.editMainDiv : ""}`}
      onClick={handleClick}
    >
      {imageUrl ? (
        <>
          <img
            src={imageUrl}
            alt={fileName || "Uploaded"}
            className={`${classes.image} ${imgClasses}`}
          />
          {mode !== "show" ? (
            <img
              src={deleteIcon}
              alt="Delete"
              className={classes.deleteIcon}
              onClick={handleDeleteModal}
            />
          ) : null}
        </>
      ) : (
        <div className="spinner-loader-container">
          <div className="spinner-loader"></div>
        </div>
      )}
    </div>
  );
};

export default Image;
